module.exports = __webpack_public_path__ + "static/media/animated-circles.2b20f25b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animated-circles.png
// module id = 163
// module chunks = 0